import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { SessionService } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/shared/services/session.service';
import { SEOService } from '@suvo/frontend/SUVO-CORE-CLIENT-LIB/projects/suvo-core-client-lib/src/lib/features/seo/services/seo.service';
import { UsersService } from '@suvo/frontend/SUVO-USERS-CLIENT-LIB/projects/suvo-users-client-lib/src/lib/features/users/services/users.service';
import { Subject } from 'rxjs';
import { filter, map, mergeMap, takeUntil } from 'rxjs/operators';
import { GoogleAnalyticsService } from './features/services/google-analytics/google-analytics.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'MBA CPR Survey Portal';
  loading = false; //Set to true to enable loading screen

  unsubscribe$: Subject<boolean> = new Subject();

  constructor(
    private router: Router,
    private userService: UsersService,
    private sessionService: SessionService,
    private activatedRoute: ActivatedRoute,
    private seoService: SEOService,
    private googleAnalyticsService: GoogleAnalyticsService,
  ) {
    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.loading = false;

        this.pageView(val.urlAfterRedirects);

        window.scrollTo(0, 0);
        document.body.scrollTop = 0;

        let matDrawer = document.getElementsByTagName('mat-drawer-content');
        let matSidenav = document.getElementsByTagName('mat-sidenav-content');

        if (matDrawer && matDrawer.length) {
          matDrawer[0].scrollTo(0, 0);
        }

        if (matSidenav && matSidenav.length) {
          matSidenav[0].scrollTo(0, 0);
        }
      }

      let userId = this.userService.userSubject?.value?._id;

      if (userId) {
        this.sessionService.handleRouteChange(userId, val);
      }
    });
  }

  ngOnInit() {
    this.router.events
      .pipe(
        filter((event) => {
          return event instanceof NavigationEnd;
        }),
        map(() => this.activatedRoute),
        map((route) => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        filter((route) => route.outlet === 'primary'),
        mergeMap((route) => route.data),
      )
      .subscribe((routeData) => {
        if (routeData.seo) {
          this.seoService.updateTitle(routeData.seo['title']);
          //Updating Description tag dynamically with title
          this.seoService.updateDescription(routeData.seo['description']);
        }
      });
  }

  onActivate(event) {
    document.body.scrollTop = 0;
  }

  pageView(urlAfterRedirects) {
    this.googleAnalyticsService.gtag({
      page_path: urlAfterRedirects,
    });
  }

  ngOnDestroy() {
    this.unsubscribe$.next(true);
  }
}
